import { useMemo } from "react";
import { Controller } from "react-hook-form";

import { ChillnnGuestPageType } from "@/lib/gql/__generated__/graphql";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { SelectField } from "@/components/ui/form/fields/select-field";

import { useGoogleFreeBookingLinksSettingsContext } from "../../../_context";

export const FormChillnnGuestPageType = () => {
	const { form, isShowHpbGuestPageTypeOption } = useGoogleFreeBookingLinksSettingsContext();
	const {
		control,
		formState: { errors },
	} = form;

	const options = useMemo(() => {
		const baseOptions = [
			{
				id: ChillnnGuestPageType.Magazine,
				label: "マガジン",
				value: ChillnnGuestPageType.Magazine,
			},
			{
				id: ChillnnGuestPageType.Plain,
				label: "プレーン",
				value: ChillnnGuestPageType.Plain,
			},
			{
				id: ChillnnGuestPageType.Snack,
				label: "スナック",
				value: ChillnnGuestPageType.Snack,
			},
		];

		if (!isShowHpbGuestPageTypeOption) {
			return baseOptions;
		}

		return [
			...baseOptions,
			{
				id: ChillnnGuestPageType.Hpb,
				label: "HPB",
				value: ChillnnGuestPageType.Hpb,
			},
		];
	}, [isShowHpbGuestPageTypeOption]);

	return (
		<QuestionForMain
			title={"CHILLNNで使用している予約ページ"}
			guide=""
			required
			inputChildren={
				<div className="flex flex-col gap-4">
					<p>
						CHILLNNで使用している予約ページを選択してください。Googleの予約リンクをクリックした際の遷移先となります。
					</p>

					<Controller
						name="chillnnGuestPageType"
						control={control}
						render={({ field }) => (
							<SelectField
								className="w-fit"
								value={field.value}
								options={options}
								errorMessage={errors?.chillnnGuestPageType?.message}
								handleValueChange={field.onChange}
							/>
						)}
					/>
				</div>
			}
		/>
	);
};
